module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/confirm_en-5a0e8ad50b10119706d35590191a24aa.png";